import { posthog } from 'posthog-js'

import { IS_SERVER } from '@/constants/runtime'
import { ShwEnv } from '@/constants/types'

import { WEBSITE_ENV } from '@/client/settings'

const SUPPORTED_ENVS = [ShwEnv.PRODUCTION]

// posthog is a "browser only" module, that fails to load in the server. So we mock
// it with a null module through Next.js config.
// This check makes sure to run the init only in the browser, because in the server
// the module is undefined
if (!IS_SERVER && SUPPORTED_ENVS.includes(WEBSITE_ENV)) {
  posthog.init('phc_b3xY0BzeqePwE2eX7tD1pZA19LeL2N943cA1ETQtuWg', {
    api_host: 'https://eu.posthog.com',
    // Posthog doesn't capture the generic route name by default, but it's useful
    // for analytical purposes (e.g. we want the generic route: `/series/[id]`).
    // So we capture pageviews manually in `trackPageView()`
    capture_pageview: false,
    autocapture: true,
  })
}

export default posthog
